import type { LeadCardViewConfig } from '@app/components/LeadCard/context';

export const LEAD_CARD_DEFAULT_VIEW_CONFIG: LeadCardViewConfig = {
  mode: 'default',
};
